import { AbstractRequestClass, DetailRequestModel } from './abstract-request.class';
import { LeaseMappingRequest } from './abstract-request.constants';
import { DataObject } from '../../../../../../models/data-object.models';

export class LeaseRequestClass extends AbstractRequestClass {
  public getMultiEndPoints(): DetailRequestModel[] | null {
    return null;
  }
  public getMappingRequest(): DataObject {
    return LeaseMappingRequest;
  }
}
